import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeletePackage(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deletePackage = (packageId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`packages/${packageId}/`);
  };

  return useMutation(deletePackage, {
    onSuccess: (_, packageId) => {
      queryClient.invalidateQueries({
        queryKey: ['billingPlans'],
      });
      queryClient.invalidateQueries({
        predicate: query => query.queryKey[0] === 'packages' && query.queryKey[1] !== packageId,
      });
    },
  });
}
